import script from "./NotificationStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationStatus.vue?vue&type=script&setup=true&lang=js"

import "./NotificationStatus.vue?vue&type=style&index=0&id=434c5c76&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-434c5c76"]])

export default __exports__